module.exports = __webpack_public_path__ + "img/OpenFBA-Sticker-Blue.3f957a6a.png";